import { MutationTree } from 'vuex';

import { FETCH_HISTORY,
  FETCH_FILTERS_META,
  HistoryState,
  UPDATE_NAVIGATION,
  REINIT,
  HISTORY_NAVIGATION,
  SET_ERROR,
  UPDATE_HISTORY_STATE,
  IHistoryStatePayload,
  SET_FILTER_CATEGORIES,
  CLEAR_FILTERS } from './types';

const mutations: MutationTree<HistoryState> = {
  [REINIT](state: HistoryState) {
    state.navigation.start = 0;
  },
  [HISTORY_NAVIGATION](state: HistoryState, { direction }) {
    const incrementValues: any = {
      forward: state.navigation.size,
      backward: state.navigation.size * -1
    };
    state.navigation.start += incrementValues[direction];
  },
  [UPDATE_HISTORY_STATE](
    state: HistoryState,
    stateToUpdate: IHistoryStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;

    state.historyState[stateKey][view] = stateValue;
  },
  [FETCH_HISTORY](state: HistoryState, payload) {
    state.history = payload;
  },
  [FETCH_FILTERS_META](state: HistoryState, payload) {
    state.filters = payload;
  },
  [SET_FILTER_CATEGORIES](state: HistoryState, filters: string[]) {
    state.selectedFilterCategories = filters;
  },
  [CLEAR_FILTERS](state: HistoryState) {
    state.selectedFilters = {
      start: 0,
      size: 20,
      deviceId: undefined,
      historyType: undefined,
      plateNumber: undefined,
      from: undefined,
      to: undefined
    };
    state.selectedFilterCategories = [];
  },
  [UPDATE_NAVIGATION](state: HistoryState, payload) {
    state.navigation = payload;
  },
  [SET_ERROR](state: HistoryState, payload) {
    state.errorMessage = payload;
  }
};

export default mutations;
